import { computed } from "vue";
import { useGuidanceStore } from "../../store/guidance";
import { useBreakpoints } from "./useBreakpoints";

export function useGuidanceSidebar() {
  const guidanceStore = useGuidanceStore();
  const { isMobile } = useBreakpoints();

  /** Пункт меню — цель текущего шага (селектор шага указывает на его data-tooltip). */
  function isStepTarget(itemId: string): boolean {
    const target = guidanceStore.currentStepConfig?.targetSelector;
    if (!target) return false;
    const selectors = Array.isArray(target) ? target : [target];
    return selectors.some((selector) => selector.includes(`submodule-${itemId}`));
  }

  const isGuidanceActive = computed(() => guidanceStore.isActive);

  function isItemHighlighted(itemId: string): boolean {
    return guidanceStore.highlightedSidebarItems.includes(itemId);
  }

  function isItemBlocked(itemId: string): boolean {
    if (!guidanceStore.isActive) return false;
    if (isItemHighlighted(itemId)) return false;

    // Телефон: выезжающее меню лежит выше затемнения тура, и через него можно
    // было уйти куда угодно из «разрешённых» разделов. На компьютере боковое
    // меню накрыто подложкой целиком — доступна только цель шага. Делаем так же:
    // на телефоне открыт только пункт, на который указывает шаг (CAB-636).
    if (isMobile.value) return !isStepTarget(itemId);

    const allowed = guidanceStore.allowedSidebarItems;
    if (allowed.length === 0) return false;

    return !allowed.includes(itemId);
  }

  return {
    isGuidanceActive,
    isItemBlocked,
    isItemHighlighted,
  };
}
